import _ from 'underscore';
import domready from 'domready';

const donationInput = document.querySelector('#booking-donation-amount');

let selectedAdditionalServices = [];
let donationAmount = 0;

function numberFormat(number, dec, dsep, tsep) {
  if (isNaN(number) || number == null) return "";
  number = Number.parseFloat(number);
  number = number.toFixed(~~dec);
  tsep = typeof tsep == "string" ? tsep : ".";
  var parts = number.split("."), fnums = parts[0], decimals = parts[1] ? (dsep || ",") + parts[1] : "";
  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, "$1" + tsep) + decimals;
}

function averagePrices(prices) {
  if (prices.length >= 2 && prices[0].average && prices[1].average) {
    var average = (Number.parseFloat(prices[0].originalprice) + Number.parseFloat(prices[1].originalprice)) / 2;
    prices[0].originalprice = average;
    prices[1].originalprice = average;
  }
  return prices;
}

domready(function () {
  var $configuration = document.getElementById("booking-departure-configuration");
  if (!$configuration) {
    return;
  }
  var $summary = document.getElementById("booking-departure-summary");
  var $personPriceSelectors = $configuration.querySelectorAll("[data-person-price-selector]");
  var template = _.template($summary.querySelector("script[type=\"text/template\"]").innerHTML);

  function render(configuration) {
    while ($summary.firstChild) $summary.removeChild($summary.firstChild);
    $summary.innerHTML = template(configuration);
  }

  /**
   * Get the selected additional services for all travelers
   */
  function getSelectedAdditionalServices() {
    selectedAdditionalServices = [];
    const travelersSections = document.querySelectorAll('.booking-additional-services__person');
    if (!travelersSections) return;

    travelersSections.forEach((traveler, i) => {
      const selectedServices = getTravelerSelectedAdditionalServices(traveler);
      selectedAdditionalServices[i] = selectedServices;
    });

    return selectedAdditionalServices;
  }

  /**
   * Get the selected additional services for a single traveler
   * @param traveler
   */
  function getTravelerSelectedAdditionalServices(traveler) {
    let travelerSelectedServices = [];
    const additionalServices = traveler.querySelectorAll('.booking-additional-services__checkbox');
    if (!additionalServices) return [];

    additionalServices.forEach((service) => {
      if (service.checked) {
        const serviceName = service.getAttribute('data-additional-services-title');
        travelerSelectedServices.push({
          name: serviceName,
          value: service.value
        });
      }
    });

    return travelerSelectedServices;
  }

  function collectSelectedPrices() {
    var selectedPrices = [];
    var $visiblePersons = Array.prototype.filter.call($personPriceSelectors, function (element) {
      if (element.parentElement.offsetWidth > 0 && element.parentElement.offsetHeight > 0) {
        return element;
      }
    });

    Array.prototype.forEach.call($visiblePersons, function (element, index) {
      var data;
      if (element.tagName === "SELECT") {
        var $selectedOptions = element.selectedOptions;
        data = Object.assign(element, $selectedOptions[0].dataset);
        data.price = parseFloat($selectedOptions[0].dataset.price);
      } else if (element.tagName === "INPUT") {
        data = Object.assign(element, element.dataset);
        data.price = parseFloat(element.dataset.price);
      }
      data.personNumber = index + 1;
      data.average = false;
      if (index === 0) {
        data.average = true;
      } else if (index === 1) {
        var allPrices = [];
        if (element.tagName === "SELECT") {
          _.each(element.options, function (option) {
            allPrices.push(option.dataset);
          });
        } else if (element.tagName === "INPUT") {
          allPrices.push(element.dataset);
        }
        if (allPrices.length === 1 && allPrices[0]["lifeStage"] === "adult" || _.uniq(_.pluck(allPrices, "price")).length === 1) {
          data.average = true;
        }
      }
      selectedPrices.push(data);
    });

    // Update donation amount according the user input
    if (donationInput) {
      donationAmount = donationInput.value ?? 0;
    }

    var configuration = {
      numberFormat: numberFormat,
      selectedPrices: averagePrices(selectedPrices),
      selectedDate: collectSelectedDate(),
      selectedAdditionalServices: getSelectedAdditionalServices(),
      donationAmount: donationAmount,
    };

    configuration.sum = _.pluck(selectedPrices, "price").reduce(function (a, b) {
      return Number.parseFloat(a) + Number.parseFloat(b);
    });

    configuration.originalsum = _.pluck(selectedPrices, "originalprice").reduce(function (a, b) {
      return Number.parseFloat(a) + Number.parseFloat(b);
    });

    // Get total amount of selected prices + the price of the selected additional services for each traveler
    configuration.sumWithAdditionalServices = () => {
      let total = Number.parseFloat(configuration.sum);
      if (!selectedAdditionalServices.length) return total;

      selectedAdditionalServices.forEach((selectedServices) => {
        if (selectedServices.length) {
          selectedServices.forEach((service) => {
            if (service.value !== '1') total += Number.parseFloat(service.value);
          });
        }
      });

      // Add the donation amount to the total
      total += donationAmount ? Number.parseFloat(donationAmount) : 0;

      return total;
    };

    // Get amount of selected prices + the price of the selected additional services for each traveler
    configuration.originalsumWithAdditionalServices = () => {
      let originalsum = Number.parseFloat(configuration.originalsum);
      if (!selectedAdditionalServices.length) return originalsum;

      selectedAdditionalServices.forEach((selectedServices) => {
        if (selectedServices.length) {
          selectedServices.forEach((service) => {
            if (service.value !== '1') originalsum += Number.parseFloat(service.value);
          });
        }
      });

      return originalsum;
    };

    return configuration;
  }


  function collectSelectedDate() {
    var from = document.getElementById("selectedDeparture");
    if (from) {
      return from.value;
    } else {
      return "";
    }
  }

  $configuration.addEventListener("personCountChanged", function (event) {
    render(collectSelectedPrices());
  });

  $configuration.addEventListener("personPriceChanged", function (event) {
    render(collectSelectedPrices());
  });

  $configuration.addEventListener("departureChanged", function (event) {
    render(collectSelectedPrices());
  });

  $configuration.addEventListener("additionalServicesChange", function (event) {
    render(collectSelectedPrices());
  });

  $configuration.addEventListener("donationInputChange", function (event) {
    render(collectSelectedPrices());
  });

  render(collectSelectedPrices());
});
